import { useState, useEffect } from 'react';
import { Box, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { FaUserLock } from 'react-icons/fa';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import API_URL from '../../config/api';
import './ListAccessLog.css';

const ListAccessLog = () => {
	const navigate = useNavigate();
	const [logs, setLog] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [searchTerm, setSearchTerm] = useState('');
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const token = JSON.parse(atob(localStorage.getItem('token') || '""'));

	useEffect(() => {
		const fetchLogs = async () => {
			try {
				const response = await fetch(`${API_URL}/api/Log/log`, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});

				if (response.ok) {
					const data = await response.json();
					setLog(data);
				} else if (response.status === 401) {
					toast.error('Sessão expirada, faça login novamente.');
					localStorage.clear();
					navigate('/');
				} else if (response.status === 403) {
					toast.warn('Acesso negado.');
				} else {
					throw new Error('Erro ao carregar logs.');
				}
			} catch (error) {
				setError(error.message);
			} finally {
				setLoading(false);
			}
		};

		fetchLogs();
	}, [navigate, token]);

	const filteredLogs = logs
		.filter(
			doc =>
				(doc.usuario ?? '')
					.toLowerCase()
					.includes(searchTerm.toLowerCase()) ||
				(doc.company ?? '')
					.toLowerCase()
					.includes(searchTerm.toLowerCase())
		)
		.filter(doc => {
			const date = new Date(doc.loginDate);
			if (startDate && date < startDate.toDate()) return false;
			if (endDate && date > endDate.toDate()) return false;
			return true;
		});

	if (loading) return <p>Carregando logs...</p>;
	if (error) return <p>Erro: {error}</p>;

	return (
		<>
			<div className="layout-wrapper">
				<Navbar />
				<div className="container">
					<h2 className="title">
						<FaUserLock
							style={{
								marginRight: '8px',
								verticalAlign: 'middle',
							}}
						/>
						Histórico de Acesso
					</h2>

					<Box className="filters">
						<TextField
							label="Buscar por nome"
							value={searchTerm}
							onChange={e => setSearchTerm(e.target.value)}
							size="small"
							className="filter-input"
						/>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker
								label="Data início"
								value={startDate}
								onChange={setStartDate}
								format="DD/MM/YYYY"
								slotProps={{ textField: { size: 'small' } }}
							/>
						</LocalizationProvider>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker
								label="Data fim"
								value={endDate}
								onChange={setEndDate}
								format="DD/MM/YYYY"
								slotProps={{ textField: { size: 'small' } }}
							/>
						</LocalizationProvider>
					</Box>

					<div className="table-wrapper">
						<table className="table">
							<thead>
								<tr>
									<th>Usuário</th>
									<th>Empresa</th>
									<th>Dispositivo</th>
									<th>Data de Acesso</th>
								</tr>
							</thead>
							<tbody>
								{filteredLogs.map(doc => (
									<tr key={doc.id}>
										<td>{doc.usuario}</td>
										<td>{doc.company}</td>
										<td>{doc.dispositivo}</td>
										<td>
											{new Date(
												doc.loginDate
											).toLocaleString()}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<ToastContainer />
				</div>
				<Footer />
			</div>
		</>
	);
};

export default ListAccessLog;